import {action, computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import defaultImage from '../../../media/background_images/default-image-sapore.jpg'
import ImageRenderer from "../../utils/ImageRenderer";
import successToast from "../../../components/toast/SuccessToast";
import errorToast from "../../../components/toast/ErrorToast";

export class ProductDetailFeature {

    constructor(application, id) {
        // TODO: Replace this with the actual data retrieved by the backend.
        this._application = application;
        this._productId = id;
        // TODO: move deliverySites to the home feature
        this._deliverySites = [];
        this._deliveryDates = [];
        this._deliveryDatesWithOrders = [];
        this._productDetailInformation = {
            Articulo: {
                Id: 1,
                CantidadUnidades: 1,
                UnidadDeItems: 'unidades',
                Producto: {
                    Nombre: 'Pan',
                    NombreFantasia: 'Pan Fantasia',
                    Descripcion: 'Descripción del producto',
                    Ingredientes: 'Ingredientes del producto',
                    Peso: 100,
                    Medidas: 10,
                    TiempoDeCoccion: 10,
                    TemperaturaDeCoccion: 100,
                    Archivos: [
                        {
                            TipoArchivo: 'Imagen Principal',
                            Url: 'url1.jpg'
                        }
                    ]
                }
            },
            PedidoInicial: {
                UsuarioCliente: {
                    Favoritos: [
                        {
                            Id: 1
                        }
                    ],
                    EsAdministrador: false,
                    Descuento: 10
                },
                VerModalMultiplePuntoEntrega: this._application.order === null,
                Cliente: {
                    Descuento: 10
                }
            },
            PrecioArticulo: 100,
            Recomendados: [
                {
                    Id: 1,
                    Producto: {
                        Nombre: 'Pan'
                    }
                },
                {
                    Id: 2,
                    Producto: {
                        Nombre: 'Pan'
                    }
                }
            ]
        }

        this._loaded = false;
        this._isAddToCartModalOpened = false;
        this._isDeliveryPointModalOpened = !this._application.wasOrderChosen();
        this.existsSameOrder = false
        this._isDeliveryPointModalOpened = !this._application.wasOrderChosen() && this.canAddProduct();
        this._isModalCantEditOrderOpened = false
        this._orderNumber = 0;

        makeObservable(this, {
            _productDetailInformation: observable,
            productDetailInformation: computed,
            _loaded: observable,
            loaded: computed,
            _deliverySites: observable,
            deliverySites: computed,
            _deliveryDates: observable,
            deliveryDates: computed,
            deliveryDatesWithOrders: computed,
            _deliveryDatesWithOrders: observable,
            _isAddToCartModalOpened: observable,
            isAddToCartModalOpened: computed,
            _isDeliveryPointModalOpened: observable,
            isDeliveryPointModalOpened: computed,
            _isModalCantEditOrderOpened: observable,
            isModalCantEditOrderOpened: computed,
            openAddToCartModal: action,
            closeAddToCartModal: action,
            openDeliveryPointModal: action,
            closeDeliveryPointModal: action,
        })
    }

    async load() {
        await this.getProduct()
        await this.getDeliverySites()
        this._finishedLoading()
    }

    _finishedLoading() {
        this._loaded = true;
    }

    async getProduct() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                this._productDetailInformation = this.convertArticleInformationResponse(response.articleInformation())
            },
            handlesError: (response) => {
                // response.errors().map(error => {
                //     this.showAlert(error);
                // })
                console.log("Error fetching article.")
            }
        });
        return this._application.apiClient().getArticle(this._productId, this._application.getCustomer().businessName,
            responseHandler);
    }

    convertArticleInformationResponse(articleInformation) {
        const article = articleInformation.article
        return {
            Articulo: {
                Id: article.code,
                CantidadUnidades: article.itemsAmount,
                UnidadDeItems: article.itemsUnit,
                Producto: {
                    Nombre: article.name,
                    NombreFantasia: article.fantasyName,
                    Categoria: article.category,
                    LogoCategoria: article.categoryImage,
                    Descripcion: article.description,
                    Ingredientes: article.ingredients,
                    Peso: article.weight,
                    Medidas: article.measures,
                    TiempoDeCoccion: article.cookingTime,
                    TemperaturaDeCoccion: article.cookingTemperature,
                    Archivos: [
                        {
                            TipoArchivo: 'Imagen Principal',
                            Url: article.file
                        },
                        {
                            TipoArchivo: 'Ficha Tecnica',
                            Url: article.specificationSheet
                        }

                    ]
                }
            },
            PrecioArticulo: articleInformation.price.amount,
            PrecioUnidad: articleInformation.unitPrice.amount,
            // DELETE DATA BELOW
            PedidoInicial: {
                UsuarioCliente: {
                    Favoritos: [
                        {
                            Id: 1
                        }
                    ],
                    EsAdministrador: false,
                    Descuento: 10
                },
                VerModalMultiplePuntoEntrega: this._application.order === null,
                Cliente: {
                    Descuento: 10
                }
            },
            Recomendados: [
                {
                    Id: 1,
                    Producto: {
                        Nombre: 'Pan'
                    }
                },
                {
                    Id: 2,
                    Producto: {
                        Nombre: 'Pan'
                    }
                }
            ]
        }
    }

    itemsUnitTitle(article) {
        const unitMapping = {
            UNITS: "Unidades",
            KG: "Kilogramos"
        };
        return unitMapping[article.UnidadDeItems] || "";
    }

    itemUnitAbbreviation(article){
        const unitMapping = {
            UNITS: "un.",
            KG: "kg."
        };
        return unitMapping[article.UnidadDeItems] || "";
    }

    get isAddToCartModalOpened() {
        return this._isAddToCartModalOpened;
    }

    set isAddToCartModalOpened(value) {
        this._isAddToCartModalOpened = value;
    }

    get isDeliveryPointModalOpened() {
        return this._isDeliveryPointModalOpened;
    }

    set isDeliveryPointModalOpened(value) {
        this._isDeliveryPointModalOpened = value;
    }

    wasDeliverySiteAndDeliveryDateChosen() {
        return this._application.wasOrderChosen()
    }

    get productDetailInformation() {
        return this._productDetailInformation;
    }

    set productDetailInformation(value) {
        this._productDetailInformation = value;
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }

    get deliverySites() {
        return this._deliverySites;
    }

    set deliverySites(value) {
        this._deliverySites = value;
    }

    get isModalCantEditOrderOpened() {
        return this._isModalCantEditOrderOpened;
    }

    set isModalCantEditOrderOpened(value) {
        this._isModalCantEditOrderOpened = value;
    }

    get deliveryDates() {
        return this._deliveryDates;
    }

    get deliveryDatesWithOrders() {
        return this._deliveryDatesWithOrders;
    }

    recommendedProducts() {
        return this.productDetailInformation.Recomendados;
    }

    productDetail() {
        return this.productDetailInformation.Articulo
    }

    productOrder() {
        return this.productDetailInformation.PedidoInicial
    }

    productPrice() {
        return this.productDetailInformation.PrecioArticulo
    }

    getDeliverySiteName(){
        if (this._application.order !== null){
            return this._application.order.deliverySite.deliverySiteName
        }
    }

    getDeliveryDate(){
        if (this._application.order !== null){
            return this._application.order.deliveryDate
        }
    }

    purchaseOrderNumber(){
        if (this._application.order !== null){
            return this._application.order.customersOrderNumber
        }
    }

    logoImage() {
        const url = this.productDetail().Producto.LogoCategoria;
        if (url.includes('invalid_url')){
            return defaultImage;
        }
        return url;
    }

    removeOrder() {
        this._application.removeOrder()
    }

    async getOrder() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                this._application.setOrder(response.order())
            },
            handlesError: async (response) => {
                if (response.orderWasDeleted?.()) {
                    await this._application.session().logOutAndRemoveOrder()
                    return errorToast("El pedido fue eliminado. Por favor, ingrese nuevamente y acceda a 'Mis Pedidos' para ver sus pedidos activos.")
                }
            }
        });
        return this._application.apiClient().orderDetail(this._application.getOrder().number, responseHandler);
    }

    async addProductToCart(quantityToAdd) {
        if (!this._application.hasOrder()) {
            this.closeAddToCartModal();
            this.openDeliveryPointModal();
            return;
        }
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                this._application.setOrder(response.order())
                this.closeAddToCartModal()
                successToast("Su producto ha sido agregado")
            },
            handlesError: async (response) => {
                if (response.editionFailed?.()) {
                    this._isModalCantEditOrderOpened = true
                } else if (response.orderWasDeleted?.()) {
                    await this._application.session().logOutAndRemoveOrder()
                    return errorToast("El pedido fue eliminado. Por favor, ingrese nuevamente y acceda a 'Mis Pedidos' para ver sus pedidos activos.")
                } else {
                    return errorToast("No se pudo editar el pedido.");
                }
            }
        });
        // const currentQuantity = this.amountOfProductInOrder(this._productId, this._application.getOrder());
        const article = {
            code: this._productId,
            // amount: currentQuantity + quantityToAdd
            amount: quantityToAdd
        }
        return this._application.apiClient().addProductToCart(this._application.getOrder().number, article, responseHandler);
    }

    productImage() {
        const url = this.productDetail().Producto.Archivos[0].Url;
        return ImageRenderer(url)
    }

    specificationSheet() {
        return this.productDetail().Producto.Archivos[1].Url
    }

    hasSpecificationSheet() {
        return !this.productDetail().Producto.Archivos[1].Url.includes('invalid_url')
    }

    openAddToCartModal() {
        this._isAddToCartModalOpened = true
    }

    closeAddToCartModal() {
        this._isAddToCartModalOpened = false
    }

    openDeliveryPointModal() {
        this._isDeliveryPointModalOpened = true
    }

    closeDeliveryPointModal() {
        this._isDeliveryPointModalOpened = false
    }

    getDeliverySites() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                this._deliverySites = response.deliverySites()
            },
            handlesError: (response) => {
                // response.errors().map(error => {
                //     this.showAlert(error);
                // })
                console.log("Error getting delivery sites")
            }
        });

        return this._application.apiClient().usersDeliverySites(responseHandler, this._application.getCustomer());
    }

    updateDeliveryDatesFor(deliverySiteName) {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                this._deliveryDates = response.enabledDates()
            },
            handlesError: (response) => {
                // response.errors().map(error => {
                //     this.showAlert(error);
                // })
                console.log("Error getting delivery sites")
            }
        });

        let deliverySite;
        for (deliverySite of this._deliverySites) {
            if (deliverySite.deliverySiteName === deliverySiteName) {
                break;
            }
        }

        return this._application.apiClient().getEnabledDatesForDeliverySite(
            deliverySite.deliverySiteCode,
            deliverySite.customer.businessName,
            responseHandler);
    }

    isDateValidForDelivery(aDateTime) {
        return this.deliveryDates.some(date => {
            const enabledDate = this.formatDate(date)
            const calendarDate = this.formatDate(new Date(aDateTime))
            return enabledDate === calendarDate
        });
    }

    formatDate(date) {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    async setDelivery(deliveryPointName, deliveryDate, purchaseOrderNumber) {
        await this.setDeliverySiteDateAndPurchaseOrderNumber(deliveryPointName, deliveryDate, purchaseOrderNumber)
    }

    async setDeliverySiteDateAndPurchaseOrderNumber(deliveryPointName, deliveryDate, purchaseOrderNumber) {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                this.setOrder(response.order());
            },
            handlesError: (response) => {
                alert("No se pudo crear el pedido.")
            }
        });

        const deliverySite = this.getDeliverySiteWithName(deliveryPointName);
        const deliveryDateString = `${deliveryDate.date()}-${deliveryDate.month()+1}-${deliveryDate.year()}`;
        const order = {
            customer: {business_name: this.getBusinessName()},
            delivery_site: {
                name: deliverySite.deliverySiteName,
                address: deliverySite.deliverySiteAddress,
                city: deliverySite.deliverySiteCity,
            },
            // delivery_date: deliveryDate
            delivery_date: deliveryDateString,
            customers_order_number: this.adaptPurchaseOrderNumber(purchaseOrderNumber)
        };
        return this._application.apiClient().createOrder(order, responseHandler);
    }

    setOrder(order) {
        this._application.setOrder(order);
    }

    order() {
        return this._application.getOrder()
    }

    adaptPurchaseOrderNumber(purchaseOrderNumber){
        if (purchaseOrderNumber === ""){
            return null
        }
        return purchaseOrderNumber
    }

    getBusinessName() {
        return this._deliverySites[0].customer.businessName;
    }

    getDeliverySiteWithName(deliveryPointName) {
        return this._deliverySites.find((deliverySite) => deliverySite.deliverySiteName === deliveryPointName)
    }

    existsAnOrderForSelectedDate() {
        return this.existsSameOrder
    }

    canAddProduct() {
        // FIXME: Duplicated code!
        const business = this._application.business();
        const userRoles = this._application.session().user().roles;
        return userRoles.includes(business.marketplace_operational_role()) || userRoles.includes(business.marketplace_general_administrator_role());
    }

    isSameOrder(orderNumbers){
        if (this._application.order !== null){
            return (orderNumbers.includes(this._application.order.number)) && (orderNumbers.length === 1)
        }
        return false
    }

    existsSameOrderWith(deliveryDate, deliverySiteString, purchaseOrderNumber) {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                if (this.isSameOrder(response.orderNumbers())) {
                    this.existsSameOrder = false
                } else {
                    this.existsSameOrder = response.existsSameOrder();
                }
            },
            handlesError: (response) => {
                alert("No se pudo crear el pedido.")
            }
        });

        const deliveryDateString = `${deliveryDate.year()}-${deliveryDate.month()+1}-${deliveryDate.date()}`;
        const deliverySite = this.getDeliverySiteWithName(deliverySiteString)
        return this._application.apiClient().existsOrderForSelectedDateAndPurchaseOrder(this.getBusinessName(),
            deliverySite.deliverySiteCode,
            deliveryDateString,
            purchaseOrderNumber,
            responseHandler);
    }
}